export default "__VITE_ASSET__DvQHOur___"